import React from 'react'
import { Table, Button, Icon, Dropdown, Statistic, Segment, Label, Grid } from 'semantic-ui-react'
import Context from './context'
import SubCellTable from './subCellTable'

function TableExamplePagination(props) {
    return (
        <Context.Consumer >
            {
                ctx => {
                    // Pagination logic
                    const currentPage = ctx.value.currentPage || 1;
                    const rowsPerPage = ctx.value.rowsPerPage || 100;
                    let allData = ctx.value.newData?.data || [];

                    // Apply filters
                    const originalDataLength = allData.length;

                    if (ctx.value.selectedVehicleFilter) {
                        allData = allData.filter(item => item.unitName === ctx.value.selectedVehicleFilter);
                    }


                    if (ctx.value.showNoWeightsOnly) {
                        // Filter to show only rides without weight
                        allData = allData.map(item => {
                            if (item.visits && item.visits.length > 0) {
                                const filteredVisits = item.visits.filter(visit => visit.weightNetWeight === "---");
                                if (filteredVisits.length > 0) {
                                    return {
                                        ...item,
                                        visits: filteredVisits
                                    };
                                }
                            }
                            return null;
                        }).filter(item => item !== null);
                    }

                    // Get unique vehicle names for dropdown
                    const originalData = ctx.value.newData?.data || [];
                    const vehicleNames = [...new Set(originalData.map(item => item.unitName))].sort();
                    const vehicleOptions = [
                        { key: 'all', text: 'الكل', value: null },
                        ...vehicleNames.map(name => ({ key: name, text: name, value: name }))
                    ];

                    // Calculate statistics for ALL data (before filtering)
                    const totalVehicles = originalData.length;
                    const totalRows = originalData.reduce((sum, item) => sum + (item.visits?.length || 0), 0);

                    // نقلات بدون وزن: النقلات التي weightNetWeight === "---"
                    const noWeightsCount = originalData.reduce((sum, item) => {
                        if (item.visits && item.visits.length > 0) {
                            return sum + item.visits.filter(visit => visit.weightNetWeight === "---").length;
                        }
                        return sum;
                    }, 0);

                    // Calculate statistics for FILTERED data
                    const filteredVehicles = allData.length;
                    const filteredRows = allData.reduce((sum, item) => sum + (item.visits?.length || 0), 0);

                    // نقلات بدون وزن في البيانات المفلترة
                    const filteredNoWeightsCount = allData.reduce((sum, item) => {
                        if (item.visits && item.visits.length > 0) {
                            return sum + item.visits.filter(visit => visit.weightNetWeight === "---").length;
                        }
                        return sum;
                    }, 0);

                    // Calculate actual displayed rows (for groups, count all visits)
                    let totalDisplayedRows = 0;
                    let paginatedData = [];

                    if (ctx.value.selectedTargetType.id === 0) {
                        // For units, one row per item
                        totalDisplayedRows = allData.length;
                        const startIdx = (currentPage - 1) * rowsPerPage;
                        const endIdx = startIdx + rowsPerPage;
                        paginatedData = allData.slice(startIdx, endIdx);
                    } else {
                        // For groups, we need to paginate by actual displayed rows
                        totalDisplayedRows = allData.reduce((sum, item) => sum + (item.visits?.length || 0), 0);

                        // Calculate which items to show on current page
                        const startRow = (currentPage - 1) * rowsPerPage;
                        const endRow = startRow + rowsPerPage;

                        let currentRow = 0;
                        let tempPaginatedData = [];

                        for (let i = 0; i < allData.length; i++) {
                            const item = allData[i];
                            const itemRowCount = item.visits?.length || 0;
                            const itemStartRow = currentRow;
                            const itemEndRow = currentRow + itemRowCount;

                            // Check if this item's rows overlap with current page
                            if (itemEndRow > startRow && itemStartRow < endRow) {
                                // Calculate which visits to show from this item
                                const visitsStartIdx = Math.max(0, startRow - itemStartRow);
                                const visitsEndIdx = Math.min(itemRowCount, endRow - itemStartRow);

                                // Clone the item and slice its visits
                                const clonedItem = {
                                    ...item,
                                    visits: item.visits.slice(visitsStartIdx, visitsEndIdx),
                                    _originalIndex: i, // Keep track of original index for numbering
                                    _globalRowStart: itemStartRow + visitsStartIdx // Starting row number for this item's first visit
                                };
                                tempPaginatedData.push(clonedItem);
                            }

                            currentRow += itemRowCount;

                            // Stop if we've passed the end of current page
                            if (currentRow >= endRow) break;
                        }

                        paginatedData = tempPaginatedData;
                    }

                    const totalPages = Math.ceil(totalDisplayedRows / rowsPerPage);

                    // Calculate startIdx for row numbering
                    const startIdx = ctx.value.selectedTargetType.id === 0
                        ? (currentPage - 1) * rowsPerPage
                        : (currentPage - 1) * rowsPerPage;

                    // Pagination controls component
                    const PaginationControls = () => (
                        totalDisplayedRows > rowsPerPage && (
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: '10px',
                                padding: '20px',
                                direction: 'rtl'
                            }}>
                                <Button
                                    icon
                                    disabled={currentPage === 1}
                                    onClick={() => ctx.actions.firstPage()}
                                    title="الصفحة الأولى"
                                >
                                    <Icon name='angle double right' />
                                </Button>

                                <Button
                                    icon
                                    disabled={currentPage === 1}
                                    onClick={() => ctx.actions.prevPage()}
                                >
                                    <Icon name='angle right' />
                                    السابق
                                </Button>

                                <span style={{ margin: '0 15px', fontWeight: 'bold' }}>
                                    صفحة {currentPage} من {totalPages} ({totalDisplayedRows} صف)
                                </span>

                                <Button
                                    icon
                                    disabled={currentPage === totalPages}
                                    onClick={() => ctx.actions.nextPage()}
                                >
                                    التالي
                                    <Icon name='angle left' />
                                </Button>

                                <Button
                                    icon
                                    disabled={currentPage === totalPages}
                                    onClick={() => ctx.actions.lastPage()}
                                    title="الصفحة الأخيرة"
                                >
                                    <Icon name='angle double left' />
                                </Button>
                            </div>
                        )
                    );

                    return (<div>
                        {/* Statistics and Filters Panel */}
                        {originalData.length > 0 && (
                            <Segment style={{ margin: '20px 0', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                                <Grid columns={2} stackable>
                                    <Grid.Column>
                                        <Statistic.Group size='small' inverted widths='three'>
                                            <Statistic>
                                                <Statistic.Value>
                                                    <Icon name='car' />
                                                    {filteredVehicles}
                                                    {filteredVehicles !== totalVehicles && <span style={{fontSize: '0.5em', opacity: 0.8}}> / {totalVehicles}</span>}
                                                </Statistic.Value>
                                                <Statistic.Label>المركبات المعروضة</Statistic.Label>
                                            </Statistic>
                                            <Statistic>
                                                <Statistic.Value>
                                                    <Icon name='list' />
                                                    {filteredRows}
                                                    {filteredRows !== totalRows && <span style={{fontSize: '0.5em', opacity: 0.8}}> / {totalRows}</span>}
                                                </Statistic.Value>
                                                <Statistic.Label>الرحلات المعروضة</Statistic.Label>
                                            </Statistic>
                                            <Statistic color='red'>
                                                <Statistic.Value>
                                                    <Icon name='ban' />
                                                    {filteredNoWeightsCount}
                                                    {filteredNoWeightsCount !== noWeightsCount && <span style={{fontSize: '0.5em', opacity: 0.8}}> / {noWeightsCount}</span>}
                                                </Statistic.Value>
                                                <Statistic.Label>نقلات بدون وزن</Statistic.Label>
                                            </Statistic>
                                        </Statistic.Group>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <div style={{ padding: '10px', background: 'rgba(255,255,255,0.1)', borderRadius: '8px' }}>
                                            <h4 style={{ color: 'white', marginBottom: '10px', textAlign: 'right' }}>
                                                <Icon name='filter' /> الفلاتر
                                            </h4>
                                            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', direction: 'rtl' }}>
                                                <Dropdown
                                                    placeholder='اختر المركبة'
                                                    search
                                                    selection
                                                    clearable
                                                    options={vehicleOptions}
                                                    value={ctx.value.selectedVehicleFilter}
                                                    onChange={(_, { value }) => ctx.actions.setVehicleFilter(value)}
                                                    style={{ minWidth: '200px' }}
                                                />
                                                <Button
                                                    toggle
                                                    active={ctx.value.showNoWeightsOnly}
                                                    onClick={ctx.actions.toggleNoWeightsFilter}
                                                    color={ctx.value.showNoWeightsOnly ? 'orange' : undefined}
                                                    icon
                                                    labelPosition='right'
                                                >
                                                    <Icon name='ban' />
                                                    بدون أوزان ({noWeightsCount})
                                                </Button>
                                                {(ctx.value.selectedVehicleFilter || ctx.value.showNoWeightsOnly) && (
                                                    <Button
                                                        onClick={ctx.actions.clearAllFilters}
                                                        icon
                                                        labelPosition='right'
                                                        basic
                                                        inverted
                                                    >
                                                        <Icon name='remove' />
                                                        إلغاء الفلاتر
                                                    </Button>
                                                )}
                                            </div>
                                            {(ctx.value.selectedVehicleFilter || ctx.value.showNoWeightsOnly) && (
                                                <div style={{ marginTop: '10px', color: 'white', textAlign: 'right' }}>
                                                    <Label color='blue' size='large'>
                                                        <Icon name='filter' />
                                                        عرض: {filteredVehicles} مركبة ({filteredRows} رحلة) من أصل {totalVehicles} مركبة ({totalRows} رحلة)
                                                    </Label>
                                                </div>
                                            )}
                                        </div>
                                    </Grid.Column>
                                </Grid>
                            </Segment>
                        )}

                        {/* Pagination Controls at Top */}
                        <PaginationControls />

                        <Table celled className="myTable">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell className="cellClass" rowSpan='2'>#</Table.HeaderCell>
                                <Table.HeaderCell className="cellClass" rowSpan='2'>المركبة</Table.HeaderCell>
                                {/* <Table.HeaderCell className="cellClass" rowSpan='2'>الحالة</Table.HeaderCell> */}
                                <Table.HeaderCell className="cellClass" colSpan='4'>تفاصيل الرحلة</Table.HeaderCell>

                                <Table.HeaderCell className="cellClass" colSpan='2'>تفاصيل الوزن</Table.HeaderCell>


                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell className="cellClass">انطلاق</Table.HeaderCell>
                                <Table.HeaderCell className="cellClass">وصول</Table.HeaderCell>
                                <Table.HeaderCell className="cellClass">الفترة</Table.HeaderCell>
                                <Table.HeaderCell className="cellClass">المسافة - كم</Table.HeaderCell>

                                <Table.HeaderCell>وزن الشحنة</Table.HeaderCell>
                                <Table.HeaderCell>وقت الشحنة</Table.HeaderCell>

                            </Table.Row>

                        </Table.Header>

                        <Table.Body>

                            {

                                ctx.value.selectedTargetType.id === 0 ? // means unit

                                    paginatedData.length > 0 ?
                                        paginatedData.map(function (value, index) {
                                            const globalIndex = startIdx + index;
                                            return (
                                                <Table.Row
                                                    style={value.status === "غ" ? { color: '#ffffff', backgroundColor: "#ff0000" } : null}
                                                    key={`unit-${globalIndex}-${value.id}`}>
                                                    <Table.Cell key={index + value.id + 'a'}>{globalIndex + 1}</Table.Cell>
                                                    <Table.Cell className="cellClass" key={index + value.id + 'b'}>{value.unitName}</Table.Cell>
                                                    {/* <Table.Cell
                                                        className="cellClass" key={index + value.id + 'b2'}>{value.status}
                                                    </Table.Cell> */}

                                                    <Table.Cell className="cellClass" key={index + value.id + 'c'}>
                                                        <SubCellTable data={value.visits.mar.details.map(e => e.in)}></SubCellTable>

                                                    </Table.Cell>
                                                    <Table.Cell className="cellClass" key={index + value.id + 'd'}>
                                                        <SubCellTable data={value.visits.mar.details.map(e => e.out)}></SubCellTable>
                                                    </Table.Cell>
                                                    <Table.Cell className="cellClass" key={index + value.id + 'e'}>
                                                        <SubCellTable data={value.visits.mar.details.map(e => e.duration)}></SubCellTable>
                                                    </Table.Cell>
                                                    <Table.Cell className="cellClass" key={index + value.id + 'f'}>
                                                        <SubCellTable data={value.visits.mar.details.map(e => e.km)}></SubCellTable>
                                                    </Table.Cell>
                                                    <Table.Cell className="cellClass" key={index + value.id + 'g'}>
                                                        {value.visits.mar.eh}
                                                    </Table.Cell>
                                                    <Table.Cell className="cellClass" key={index + value.id + + 'h'}>
                                                        {value.visits.mar.parkings}
                                                    </Table.Cell>

                                                    <Table.Cell className="cellClass" key={index + value.id + 'i'}>
                                                        <SubCellTable data={value.visits.mak.details.map(e => e.in)}></SubCellTable>
                                                    </Table.Cell>
                                                    <Table.Cell className="cellClass" key={index + value.id + 'j'}>
                                                        <SubCellTable data={value.visits.mak.details.map(e => e.out)}></SubCellTable>
                                                    </Table.Cell>
                                                    <Table.Cell className="cellClass" key={index + value.id + 'k'}>
                                                        <SubCellTable data={value.visits.mak.details.map(e => e.duration)}></SubCellTable>
                                                    </Table.Cell>

                                                    <Table.Cell className="cellClass" key={index + value.id + 'l'}>
                                                        <SubCellTable data={value.visits.mah.details.map(e => e.in)}></SubCellTable>
                                                    </Table.Cell>
                                                    <Table.Cell className="cellClass" key={index + value.id + 'm'}>
                                                        <SubCellTable data={value.visits.mah.details.map(e => e.out)}></SubCellTable>
                                                    </Table.Cell>
                                                    <Table.Cell className="cellClass" key={index + value.id + 'n'}>
                                                        <SubCellTable data={value.visits.mah.details.map(e => e.duration)}></SubCellTable>
                                                    </Table.Cell>
                                                </Table.Row>
                                            )
                                        })
                                        :
                                        null

                                    : // if selected type id is 1 means for group
                                    paginatedData.length > 0 ?
                                        paginatedData.map(function (value, index) {
                                            //  if (value.visits.length === 0 || value.weights.length === 0) return 0;
                                            // console.log(value)
                                            const globalIndex = startIdx + index;
                                            let view = constuctView(value, globalIndex)
                                            // for (let i = 0; i < value.visits.length; i++) {
                                            //     if( value.weights[i].le){
                                            //   view += constuctView(value, index, 0)
                                            //     }

                                            // }
                                            return view
                                        })
                                        :
                                        null

                            }
                        </Table.Body>

                        <Table.Footer>
                            <Table.Row>

                            </Table.Row>
                        </Table.Footer>
                    </Table>

                    {/* Pagination Controls at Bottom */}
                    {console.log('Pagination Debug:', { totalDisplayedRows, rowsPerPage, currentPage, totalPages, shouldShow: totalDisplayedRows > rowsPerPage })}
                    <PaginationControls />
                    </div>)
                }
            }
        </Context.Consumer>
    )

}

function constuctView(value, index) {
    let array = []
    // Use _globalRowStart if available (for pagination), otherwise use index
    const baseRowNumber = value._globalRowStart !== undefined ? value._globalRowStart : index;

    for (let i = 0; i < value.visits.length; i++) {
        const rowNumber = baseRowNumber + i + 1;
        const uniqueKey = `group-${value.id}-visit-${i}-row-${rowNumber}`;

        array.push(<Table.Row
            style={value.visits[i].weightNetWeight === "---" ? { color: '#ffffff', backgroundColor: "#ff0000" } : null}
            key={uniqueKey}>
            <Table.Cell key={uniqueKey + '-a'}>{rowNumber}</Table.Cell>
            <Table.Cell className="cellClass" key={uniqueKey + '-b'}>{value.unitName}</Table.Cell>
            {/* <Table.Cell className="cellClass" key={uniqueKey + '-b2'}>{value.status}</Table.Cell> */}

            <Table.Cell className="cellClass" key={uniqueKey + '-c'}>
                <SubCellTable data={value.visits[i].t1}></SubCellTable>
            </Table.Cell>
            <Table.Cell className="cellClass" key={uniqueKey + '-d'}>
                <SubCellTable data={value.visits[i].t2}></SubCellTable>
            </Table.Cell>
            <Table.Cell className="cellClass" key={uniqueKey + '-e'}>
                <SubCellTable data={value.visits[i].duration}></SubCellTable>
            </Table.Cell>
            <Table.Cell className="cellClass" key={uniqueKey + '-f'}>
                <SubCellTable data={value.visits[i].km}></SubCellTable>
            </Table.Cell>


            <Table.Cell className="cellClass" key={uniqueKey + '-g'}>
                <SubCellTable data={value.visits[i].weightNetWeight}></SubCellTable>
            </Table.Cell>
            <Table.Cell className="cellClass" key={uniqueKey + '-h'}>
                <SubCellTable data={value.visits[i].weightDate}></SubCellTable>
            </Table.Cell>

        </Table.Row>
        )
    }
    return array
}


export default TableExamplePagination